import {
  runTrigger as publicRunTrigger,
  bulkUpdateMainEntityTags as publicBulkUpdateMainEntityTags,
  bulkUpdateMainEntityTagsByFilter as publicBulkUpdateMainEntityTagsByFilter,
} from './automations-v1-automations-custom-trigger-custom-trigger.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const runTrigger: MaybeContext<
  BuildRESTFunction<typeof publicRunTrigger> & typeof publicRunTrigger
> = /*#__PURE__*/ createRESTModule(publicRunTrigger);
/** @internal */
export const bulkUpdateMainEntityTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMainEntityTags> &
    typeof publicBulkUpdateMainEntityTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMainEntityTags);
/** @internal */
export const bulkUpdateMainEntityTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMainEntityTagsByFilter> &
    typeof publicBulkUpdateMainEntityTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMainEntityTagsByFilter);

export {
  MainEntity,
  Tags,
  TagList,
  RunTriggerRequest,
  RunTriggerResponse,
  BulkUpdateMainEntityTagsRequest,
  BulkUpdateMainEntityTagsResponse,
  BulkUpdateMainEntityTagsByFilterRequest,
  BulkUpdateMainEntityTagsByFilterResponse,
  RunTriggerOptions,
  BulkUpdateMainEntityTagsOptions,
  BulkUpdateMainEntityTagsByFilterOptions,
} from './automations-v1-automations-custom-trigger-custom-trigger.universal.js';
